import * as React from 'react';
import { ExpandableParagraph, Typography } from 'omakase';
import ConsumerDisplayMoney from 'components/ConsumerDisplayMoney';

interface ModifierCompactItemProps {
  description?: string;
  isSoldOut: boolean;
  name: string;
  price: number;
}

const ModifierCompactItem: React.FunctionComponent<ModifierCompactItemProps> = ({
  name,
  description,
  price,
  isSoldOut,
}) => {
  return (
    <div>
      <Typography
        component="h3"
        variant="body02Strong"
        mb={0.5}
        color={isSoldOut ? 'fgSubtle' : 'fgDefault'}
      >
        {name}
      </Typography>
      {description && (
        <ExpandableParagraph
          variant="caption"
          color={isSoldOut ? 'fgDisabled' : 'fgSubtle'}
          paragraphText={description}
          linkify={true}
          cutoffLength={255}
        />
      )}
      {price > 0 && (
        <Typography
          component="h2"
          variant="body02Strong"
          color={isSoldOut ? 'fgDisabled' : 'fgSubtle'}
        >
          <ConsumerDisplayMoney amount={price} />
        </Typography>
      )}
    </div>
  );
};

export default ModifierCompactItem;
